import { IApiResponse, IAuthRequest, IAuthResponse, IRefreshTokenRequest } from 'types'
import { AUTH, REFRESH_TOKEN } from './CONSTANTS'
import { request } from 'services/base'

export const authenticate = async (payload: IAuthRequest): Promise<IApiResponse<IAuthResponse>> =>
  await request({ url: AUTH, method: 'post', data: payload, removeBearer: true })

export const refreshToken = async (payload: IRefreshTokenRequest): Promise<IApiResponse<IAuthResponse>> =>
  await request({ url: REFRESH_TOKEN, method: 'post', data: payload, removeBearer: true })
